<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-25 -25 160 160"
    height="65px"
    width="65px"
    :style="'fill:' + color"
  >
    <g transform="rotate(180 65 65)">
      <rect style="fill: #a7a9ac;" y="38.28" width="128" height="29.91"></rect>
      <rect style="fill: #939598;" y="68.18" width="128" height="29.91"></rect>
      <rect style="fill: #808285;" y="98.09" width="128" height="29.91"></rect>
      <polygon
        style="fill: #231f20;
          stroke: #231f20;
          stroke-miterlimit: 10;
          stroke-width: 3px;"
        points="61.26 4.93 59.08 2.75 35.71 26.12 12.35 2.75 10.17 4.93 33.53 28.3 33.52 28.32 35.69 30.5 35.71 30.48 35.73 30.5 37.91 28.32 37.89 28.3 61.26 4.93"
      ></polygon>
      <polygon
        style="fill: #231f20;
          stroke: #231f20;
          stroke-miterlimit: 10;
          stroke-width: 3px;"
        points="118.79 28.32 116.61 30.5 93.24 7.13 69.88 30.5 67.7 28.32 91.07 4.95 91.05 4.93 93.22 2.75 93.24 2.77 93.26 2.75 95.44 4.93 95.42 4.95 118.79 28.32"
      ></polygon>
    </g>
  </svg>
</template>

<script>
export default {
  props: ["seatNo", "color", "pointer"],
  data() {
    return {};
  },
  methods: {
    clickSeat() {
      console.log("Emit Click Seat");
      this.$emit("clickSeat");
    }
  }
};
</script>
